import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output, Signal, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TsDataSet } from '../../../services/model';

type TsDataSetHtml = TsDataSet & {
  controlLabelName: string;
  controlLeftName: string;
  controlLeftV1Name: string;
  controlLeftV3Name: string;
  controlRightName: string;
  controlRightV1Name: string;
  controlRightV3Name: string;
};

@Component({
  selector: 'app-dynamic-table-input-ts',
  standalone: true,
  imports: [CommonModule, FormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, ReactiveFormsModule],
  templateUrl: './dynamic-table-input-ts.component.html',
  styleUrl: './dynamic-table-input-ts.component.scss',
})
export class DynamicTableInputTsComponent implements OnInit {
  private fb: UntypedFormBuilder = inject(UntypedFormBuilder);
  @Input() title: string | undefined = '';
  @Input() data: Array<TsDataSet> = [];
  @Input() note: string = '';
  @Input() startTabIndex: number = 0;
  @Input() isTwoSided = true;
  @Output() inputData = new EventEmitter<{ data: Array<TsDataSet>; note: string }>(true);
  dataHtml: Array<TsDataSetHtml> = [];
  form: FormGroup = new FormGroup({});
  private valueChanges: Signal<unknown> | undefined;
  // private formDataEffect = effect(() => {
  //   console.log('value Changes', this.valueChanges());

  //   this.inputData.emit(this.valueChanges());
  // });
  constructor(private injector: Injector) {}

  ngOnInit() {
    this.form = this.fb.group({
      ...this.data
        .flatMap(row => {
          return [
            { [row.name + '_label']: [row.label] },
            { [row.name + '_left']: [row.left.value, Validators.min(row.min ?? 0)] },
            { [row.name + '_leftV1']: [row.left.angleV1, Validators.min(-180)] },
            { [row.name + '_leftV3']: [row.left.angleV3, Validators.min(-180)] },
            { [row.name + '_right']: [row.right.value, Validators.min(row.min ?? 0)] },
            { [row.name + '_rightV1']: [row.right.angleV1, Validators.min(-180)] },
            { [row.name + '_rightV3']: [row.right.angleV3, Validators.min(-180)] },
          ];
        })
        .reduce((prev, current) => {
          const [key] = Object.keys(current);
          const value = current[key];
          prev[key] = value;
          return prev;
        }, {}),
      note: [this.note],
    });

    this.valueChanges = toSignal(this.form.valueChanges, { injector: this.injector });

    effect(
      () => {
        const formData = this.valueChanges!() as object;
        console.log('formData valueChanges', formData);
        if (formData) {
          const newData: Array<TsDataSet> = [];
          this.data.forEach((row, zeroBasedIndex) => {
            const index = zeroBasedIndex + 1;
            const propStart = 'test' + index;
            newData.push({
              ...row,
              label: this.hasDynamicProperty(formData, propStart + '_label')
                ? (formData[propStart + '_label'] as string)
                : '',
              left: {
                value: this.hasDynamicProperty(formData, propStart + '_left')
                  ? (formData[propStart + '_left'] as number)
                  : null,
                angleV1: this.hasDynamicProperty(formData, propStart + '_leftV1')
                  ? (formData[propStart + '_leftV1'] as number)
                  : null,
                angleV3: this.hasDynamicProperty(formData, propStart + '_leftV3')
                  ? (formData[propStart + '_leftV3'] as number)
                  : null,
              },
              right: {
                value: this.hasDynamicProperty(formData, propStart + '_right')
                  ? (formData[propStart + '_right'] as number)
                  : null,
                angleV1: this.hasDynamicProperty(formData, propStart + '_rightV1')
                  ? (formData[propStart + '_rightV1'] as number)
                  : null,
                angleV3: this.hasDynamicProperty(formData, propStart + '_rightV3')
                  ? (formData[propStart + '_rightV3'] as number)
                  : null,
              },
            });
          });
          const note: string = this.hasDynamicProperty(formData, 'note') ? formData['note'] : '';
          this.inputData.emit({ note, data: newData });
        }
      },
      { injector: this.injector }
    );

    this.dataHtml = this.data.map(row => {
      return {
        ...row,
        controlLabelName: row.name + '_label',
        controlLeftName: row.name + '_left',
        controlLeftV1Name: row.name + '_leftV1',
        controlLeftV3Name: row.name + '_leftV3',
        controlRightName: row.name + '_right',
        controlRightV1Name: row.name + '_rightV1',
        controlRightV3Name: row.name + '_rightV3',
      };
    });
  }

  hasDynamicProperty(obj: any, propName: string): obj is { [key: string]: any } {
    return typeof obj === 'object' && obj !== null && propName in obj;
  }

  getMinMAxValue(value: number | null, row: TsDataSet): number | null {
    if (row.min !== null && row.min !== undefined && row.max !== null && row.max !== undefined && value !== null) {
      if (value > row.max) {
        return row.max;
      } else if (value < row.min) {
        return row.min;
      } else {
        return value;
      }
    } else {
      return value;
    }
  }

  onInputChange($event: any, controlName: string, row: TsDataSet) {
    // console.log('onInputChange', row);

    // if ($event.target) {
    //   console.log('$event.target.value', $event.target.value);
    //   $event.target.value = this.getMinMAxValue(Number($event.target.value), row);
    //   this.form.controls[controlName].patchValue(this.getMinMAxValue(Number($event.target.value), row));
    // }
  }

  onAddMuskelgruppe() {
    const rowName = 'test' + (this.data.length + 1);

    this.form.addControl(rowName + '_label', new FormControl<string | null>(''));
    this.form.addControl(rowName + '_left', new FormControl<number | null>(null));
    this.form.addControl(rowName + '_leftV1', new FormControl<number | null>(null));
    this.form.addControl(rowName + '_leftV3', new FormControl<number | null>(null));
    this.form.addControl(rowName + '_right', new FormControl<number | null>(null));
    this.form.addControl(rowName + '_rightV1', new FormControl<number | null>(null));
    this.form.addControl(rowName + '_rightV3', new FormControl<number | null>(null));

    this.data.push({ ...this.data[0], name: rowName });

    this.dataHtml.push({
      ...this.dataHtml[0],
      name: rowName,
      controlLabelName: rowName + '_label',
      controlLeftName: rowName + '_left',
      controlLeftV1Name: rowName + '_leftV1',
      controlLeftV3Name: rowName + '_leftV3',
      controlRightName: rowName + '_right',
      controlRightV1Name: rowName + '_rightV1',
      controlRightV3Name: rowName + '_rightV3',
    });
  }
}
